import api from './axios';
import { Supplier } from '../types';

export const suppliersApi = {
  getAll: () => api.get<Supplier[]>('/suppliers'),

  getById: (id: number) => api.get<Supplier>(`/suppliers/${id}`),

  create: (data: Partial<Supplier>) => api.post<Supplier>('/suppliers', data),

  update: (id: number, data: Partial<Supplier>) =>
    api.put<Supplier>(`/suppliers/${id}`, data),

  delete: (id: number) => api.delete(`/suppliers/${id}`),
};
